var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"search"},[(_vm.onlineSearch)?_c('nc-search',{on:{"addProduct":function($event){return _vm.addProduct($event)}}}):_c('offline-search',{on:{"addProduct":function($event){return _vm.addProduct($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }